/**
 * @desc 修改年计划基础信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.PlanYearUpdateRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/plan/year/updatePlanInfo',
    data,
  });
}

export function mock(
  data: defs.PlanYearUpdateRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/plan/year/updatePlanInfo',
    data,
  });
}
